import { searchPolicies } from '../../../api/policies.api';

interface PolicyNumberAndProduct {
  policyNumber: string;
  product: string;
}

export const getPolicyNumberAndProduct =
  async (): Promise<PolicyNumberAndProduct> => {
    try {
      const response = await searchPolicies();
      const policy = response.data.content?.at(0);

      if (!policy) {
        throw new Error('No policy found');
      }

      const { policyNumber, product } = policy;

      return { policyNumber, product };
    } catch (error) {
      console.error('Error fetching policy number and product:', error);
      return { policyNumber: '', product: '' };
    }
  };
